import React, { useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { HashLink as Link } from 'react-router-hash-link';
import LeftNavigationModule
  from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/LeftNavigationModule';

import { Metadata } from '@thd-olt-component-react/metadata';
import { Row, Col } from '@thd-olt-component-react/grid';
import RowHeader
  from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/RowHeader';
import EtchRichText
  from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/EtchRichText';
import Image from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/Image';
import { Breadcrumb } from '@thd-olt-component-react/etch-widgets/dist/components/etch1/Etch1';
import BlockHeader
  from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/BlockHeader';
import { PrivacyMetadata } from './PrivacyMetadata';
import mostViewedNavOpts from './jsonData/leftNavOptions/MostViewed.json';
import aboutMyOrderOpts from './jsonData/leftNavOptions/AboutMyOrderOpts.json';
import shippingAndDeliveryOpts from './jsonData/leftNavOptions/ShippingAndDeliveryOpts.json';
import productAndServicesOpts from './jsonData/leftNavOptions/ProductAndServices.json';
import pricingAndPromosOpts from './jsonData/leftNavOptions/PricingAndPromos.json';
import paymentsOpts from './jsonData/leftNavOptions/paymentsOpts.json';
import myAccount from './jsonData/leftNavOptions/MyAccountOpts.json';
import returnsAndRecallsOpts from './jsonData/leftNavOptions/ReturnsAndRecallsOpts.json';
import policiesAndLegalOpts from './jsonData/leftNavOptions/PoliciesAndLegalOpts.json';
import corporateInformationOpts from './jsonData/leftNavOptions/CorporateInformationOpts.json';
import contactUsOpts from './jsonData/leftNavOptions/ContactUsOpts.json';
import * as About from './SecurityPages/securityContents/AboutOpts';
import * as whatData from './SecurityPages/securityContents/WhatDataOpts';
import * as collectData from './SecurityPages/securityContents/DataCollect';
import * as dataUsage from './SecurityPages/securityContents/DataUsageOpts';
import * as dataSharing from './SecurityPages/securityContents/DataSharingOpts';
import * as marketing from './SecurityPages/securityContents/MarketingOpts';
import * as sites from './SecurityPages/securityContents/SitesOpts';
import * as californiaPrivacy from './SecurityPages/securityContents/CaliforniaRightsOpts';
import * as security from './SecurityPages/securityContents/SecurityOpts';
import * as links from './SecurityPages/securityContents/LinksOpts';
import * as contacts from './SecurityPages/securityContents/ContactOpts';
import * as tracking from './SecurityPages/securityContents/TrackingToolsOpts';
import * as accountInfo from './SecurityPages/securityContents/AccountRegisteration';
import * as homedepotFoundation from './SecurityPages/securityContents/HomeDepotFoundation';
import * as applicantInfo from './SecurityPages/securityContents/ApplicantInfoOpts';
import { contentgridUrl } from '../../constants';

const etchStories = [
  {
    storyOpt: {
      id: 'Security',
      images: null
    },
    pictureOpt: {
      mediaData: {
        src: contentgridUrl + '/hdus/en_US/DTCCOMNEW/fetch/NexGen/ContentPage/Privacy-Security-banner-desktop.png',
        alt: 'Shop With Privacy and Security'
      },
      mediaMobileData: {
        src: contentgridUrl + '/hdus/en_US/DTCCOMNEW/fetch/NexGen/ContentPage/Privacy-Security-banner-mobile.png',
        alt: 'Shop With Privacy and Security'
      }
    }
  }];
const richText = {
  id: 'section1',
  html:
    '                <p>The Home Depot values and respects the privacy of its customers and visitors.\n'
    + '                 In the course of operating our business and interacting with you, we collect, \n'
    + '                 use, and share personal information. We do so to process and fulfill your orders,\n'
    + '                 to improve our in-store and digital offerings, to create consistent in-store \n'
    + '                 and digital experiences for you,to protect the rights and information of our \n'
    + '                 customers and our company,and for the other purposes disclosed in this Privacy \n'
    + '                 and Security Statement.</p>\n'
    + '                <p><br/></p>\n'
    + '                <p>This Privacy and Security Statement provides you with information about how \n'
    + '                  we collect use, and share personal information, and describes choices and  \n'
    + '                  rights available regarding your personal information. If you have any questions,\n'
    + '                  please contact us via the channels listed below. </p> \n'
};

const metadata = {
  title: 'Privacy and Security Statement - The Home Depot',
  description: ' Customer privacy is important to The Home Depot. Our Privacy and Security Statement '
    + 'provides a summary of the personal information we collect and how we use it, '
    + 'our privacy practices, as well as your choices and rights.',
  canonical: 'https://www.homedepot.com/privacy/Privacy_Security'
};

export const Security = () => {
  const { channel } = useContext(ExperienceContext);
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('exerciseMyPrivacyRights.static.page-load', {
      pageName: 'privacy and security statement',
      pageType: 'content',
      primaryCategory: 'privacy and security statement',
      subCategory1: 'privacy and security statement',
      subCategory2: 'privacy and security statement'
    });
  });
  return (
    <div className="container">

      <Metadata>
        <PrivacyMetadata
          title={metadata.title}
          description={metadata.description}
          canonical={metadata.canonical}
        />
      </Metadata>

      <Row>
        <Col>
          <Breadcrumb breadCrumbs={[
            {
              url: '',
              label: 'Privacy and Security Statement'
            }]}
          />
          <h1 className="page-header">The Home Depot, Inc. Privacy and Security Statement</h1>
        </Col>
      </Row>

      <Row>
        {channel !== 'mobile' && (
          <Col sm="2" md="2" lg="2" xs="12">
            <LeftNavigationModule opts={mostViewedNavOpts} />
            <LeftNavigationModule opts={aboutMyOrderOpts} />
            <LeftNavigationModule opts={shippingAndDeliveryOpts} />
            <LeftNavigationModule opts={productAndServicesOpts} />
            <LeftNavigationModule opts={pricingAndPromosOpts} />
            <LeftNavigationModule opts={paymentsOpts} />
            <LeftNavigationModule opts={myAccount} />
            <LeftNavigationModule opts={returnsAndRecallsOpts} />
            <LeftNavigationModule opts={policiesAndLegalOpts} />
            <LeftNavigationModule opts={corporateInformationOpts} />
            <LeftNavigationModule opts={contactUsOpts} />
          </Col>
        ) }
        <Col sm="10" md="10" lg="10" xs="12">
          <Row>
            <Col>
              <Row>

                {etchStories && etchStories.map((story) => {
                  return (
                    <Col sm="12" md="12" lg="12" xs="12">
                      <Image opts={story.pictureOpt} channel={channel} />
                    </Col>
                  );
                })}

              </Row>
            </Col>
            <Col>
              <EtchRichText opts={richText} />
            </Col>
            <Col>
              <Row>
                <Col sm="4" md="4" lg="4" xs="4">
                  <p> <Link to="#AboutThisStatement"> About this Statement </Link> </p>
                  <p> <Link to="#WhatWeCollect">What Do We Collect? </Link></p>
                  <p> <Link to="#CollectInformation">How Do We Collect Information? </Link></p>
                  <p> <Link to="#InformationUsage">How Do We Use Information? </Link></p>
                  <p> <Link to="#InformationSharing">Information Sharing  </Link></p>
                  <p> <Link to="#MarketingPreferences">Manage Marketing Preferences </Link></p>
                </Col>
                <Col sm="4" md="4" lg="4" xs="4">
                  <p> <Link to="#SitesAndChildren">Our Sites and Children  </Link></p>
                  <p> <Link to="#CaliforniaPrivacyRights">Your California Privacy Rights </Link></p>
                  <p> <Link to="#Security">Security </Link></p>
                  <p> <Link to="#Links">Links </Link></p>
                  <p> <Link to="#ContactUs">Contact Us </Link></p>
                </Col>
                <Col sm="4" md="4" lg="4" xs="4">
                  <p> <Link to="#TrackingTools">Our Tracking Tools  </Link></p>
                  <p> <Link to="#MyAccountRegistration">My Account Registration and Use </Link></p>
                  <p> <Link to="#HomeDepotFoundation">The Home Depot Foundation </Link></p>
                  <p> <Link to="#InformationForApplicants">Information for Applicants </Link></p>
                </Col>
              </Row>
            </Col>

            <Col>
              <RowHeader opts={About.header1} />
            </Col>
            <Col>
              <EtchRichText opts={About.richText1} />
            </Col>
            <Col>
              <RowHeader opts={whatData.header} />
            </Col>
            <Col>
              <EtchRichText opts={whatData.richText} />
            </Col>
            <Row>

              {whatData.etchStories && whatData.etchStories.map((story) => {
                return (
                  <Col sm="3" md="3" lg="3" xs="3">
                    <BlockHeader opts={story.subHeader} />
                    <EtchRichText opts={story.textOpt} />
                  </Col>
                );
              })}

            </Row>
            <Col>
              <RowHeader opts={collectData.header} />
            </Col>
            <Col>
              <EtchRichText opts={collectData.richText1} />
            </Col>
            <Col>
              <RowHeader opts={dataUsage.header} />
            </Col>
            <Col>
              <EtchRichText opts={dataUsage.richText1} />
            </Col>
            <Col>
              <RowHeader opts={dataSharing.header} />
            </Col>
            <Col>
              <EtchRichText opts={dataSharing.richText1} />
            </Col>
            <Col>
              <RowHeader opts={marketing.header} />
            </Col>
            <Col>
              <EtchRichText opts={marketing.richText1} />
            </Col>
            <Col>
              <RowHeader opts={sites.header} />
            </Col>
            <Col>
              <EtchRichText opts={sites.richText1} />
            </Col>
            <Col>
              <RowHeader opts={californiaPrivacy.header} />
            </Col>
            <Col>
              <EtchRichText opts={californiaPrivacy.richText1} />
            </Col>
            <Col>
              <RowHeader opts={security.header} />
            </Col>
            <Col>
              <EtchRichText opts={security.richText1} />
            </Col>
            <Col>
              <RowHeader opts={links.header} />
            </Col>
            <Col>
              <EtchRichText opts={links.richText1} />
            </Col>
            <Col>
              <RowHeader opts={contacts.header} />
            </Col>
            <Col>
              <EtchRichText opts={contacts.richText1} />
            </Col>
            <Col>
              <RowHeader opts={tracking.header} />
            </Col>
            <Col>
              <EtchRichText opts={tracking.richText1} />
            </Col>
            <Col>
              <RowHeader opts={accountInfo.header} />
            </Col>
            <Col>
              <EtchRichText opts={accountInfo.richText1} />
            </Col>
            <Col>
              <RowHeader opts={homedepotFoundation.header} />
            </Col>
            <Col>
              <EtchRichText opts={homedepotFoundation.richText1} />
            </Col>
            <Col>
              <RowHeader opts={applicantInfo.header} />
            </Col>
            <Col>
              <EtchRichText opts={applicantInfo.richText1} />
            </Col>

          </Row>

        </Col>

      </Row>

    </div>
  );
};
